import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useReducer, useState, useRef } from 'react';
import { toast } from 'react-toastify';
import Dialog from '../components/dialog.jsx';
import passwordVerification from '../components/passwordVerification.js';
import Alert from '../components/alert.js';

const initialPodcast = {
    podcastName: "",
    podcastId: null,
    email: null,
    emailToken: null,
    hosted: false
};

const podcastReducer = (state, action) => {
    if (action.reset) {
        return initialPodcast
    }
    var newState = {...state};
    newState[action.key] = action.value;
    return newState;
};

function JoinPodcast() {
    const navigate = useNavigate();
    const [podcast, dispatch] = useReducer(podcastReducer, initialPodcast);
    const [loading, setLoading] = useState(false);
    const [lock, setLock] = useState(false);
    const [claimState, setClaimState] = useState('select');
    const [podcastList, setPodcastList] = useState([]);
    const [descriptionToken, setDescriptionToken] = useState(null);
    const claimPodcastRef = useRef(null);
    const validate = () => {
        var errors = [];
        if (podcast.podcastName.trim() == '')
            errors.push('Please enter the name of your podcast.');
        return errors;
    }
    const loadPodcasts = () => {
        if (loading || lock)
            return;
        var err = validate();
        if (err.length === 0) {
            setLoading(true);
            axios.post(process.env.REACT_APP_API_URL + 'podcast/name', {
                name: podcast.podcastName
            }).then((r) => {
                    setLoading(false);
                    if (r?.data?.status == 'Success') {
                        claimPodcastRef.current.show();
                        setPodcastList(r.data.results);
                        if (r.data.results.length == 0) {
                            setClaimState('create');
                        }
                    }
                }).catch(e => setLoading(false));
        } else {
            let t_id = toast.error(<div>{err.map(e => <div>{e}</div>)}</div>);
            setTimeout(() => toast.dismiss(t_id), 2000)
        }
    }
    const claimPodcast = (id) => {
        if (loading || lock)
            return;
        if (!id) {
            const err = ['The selected podcast\'s id was not found'];
            let t_id = toast.error(<div>{err.map(e => <div>{e}</div>)}</div>);
            setTimeout(() => toast.dismiss(t_id), 2000)
            return;
        }
        dispatch({ key: 'podcastId', value: id });
        setLoading(true);
        axios.post(process.env.REACT_APP_API_URL + 'podcast/get/email', {
            id: id
        }).then((r) => {
                setLoading(false);
                if (r?.data?.status == 'Success') {
                    dispatch({ key: 'email', value: r.data.results.masked});
                    dispatch({ key: 'emailToken', value: r.data.results.emailToken});
                    setClaimState('email-view');
                } else if (r?.data?.status == 'NoEmail') {
                    setDescriptionToken(r.data.descriptionToken);
                    setClaimState('no-email');
                } else {
                    if (r?.data?.message) {
                        let t_id = toast.error(r.data.message);
                        setTimeout(() => toast.dismiss(t_id), 2000);
                    } else {
                        let t_id = toast.error("There was an unexpected error.");
                        setTimeout(() => toast.dismiss(t_id), 2000);
                    }
                }
            }).catch(e => setLoading(false));
    }
    const sendClaimEmail = () => {
        if (loading || lock)
            return;
        setLoading(true);
        console.log(podcast);
        axios.post(process.env.REACT_APP_API_URL + 'podcast/verification/send', {
            emailToken: podcast.emailToken,
            podcastId: podcast.podcastId
        }).then((r) => {
            setLoading(false);
            if (r?.data?.status == 'Success') {
                setClaimState('email-sent');
                setLock(true);
            } else {
                if (r?.data?.message) {
                    let t_id = toast.error(r.data.message);
                    setTimeout(() => toast.dismiss(t_id), 2000);
                } else {
                    let t_id = toast.error("There was an unexpected error.");
                    setTimeout(() => toast.dismiss(t_id), 2000);
                }
            }
        }).catch(e => {
            console.log(e);
            setLoading(false)
        });
    }
    const createPodcast = () => {
        if (loading || lock)
            return;
        var err = validate();
        if (err.length === 0) {
            setLoading(true);
            axios.post(process.env.REACT_APP_API_URL + 'podcast/user/create', {
                podcastName: podcast.podcastName,
                hosted: podcast.hosted
            }).then((r) => {
                    setLoading(false);
                    if (r?.data?.token) {
                        setLock(true);
                        localStorage.setItem('jwt', r.data.token);
                        setTimeout(() => navigate(r.data.to), 1750);
                        toast.success('Successfully created a podcast.');
                    }
                }).catch(e => setLoading(false));
        } else {
            let t_id = toast.error(<div>{err.map(e => <div>{e}</div>)}</div>);
            setTimeout(() => toast.dismiss(t_id), 2000)
        }
    }
    const verifyDescription = () => {
        if (loading || lock)
            return;

        setLoading(true);
        axios.post(process.env.REACT_APP_API_URL + 'podcast/verification/description', {
            podcastName: podcast.podcastName
        }).then((r) => {
                setLoading(false);
                if (r?.data?.token) {
                    setLock(true);
                    localStorage.setItem('jwt', r.data.token);
                    setTimeout(() => navigate(r.data.to), 1750);
                    toast.success('Successfully verified your ownership of the podcast.');
                } else {
                    let t_id = toast.error('We could not verify your ownership of the podcast, please try again.');
                    setTimeout(() => toast.dismiss(t_id), 4000);
                }
            }).catch(e => setLoading(false));
    }
    const closeDialog = () => {
        setClaimState('select');
        setPodcastList([]);
        dispatch({ reset: true });
    }
    return (
        <>
            <Dialog ref={claimPodcastRef} onClose={closeDialog} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    {claimState != 'email-sent' && (
                        <button className="btn btn-white" onClick={() => {
                            claimPodcastRef.current.hide();
                            closeDialog();
                        }}>Cancel</button>
                    )}
                    {claimState == 'select' && (
                        <button className="btn btn-white" onClick={() => {
                            setClaimState('create');
                        }}>I Don't See My Podcast</button>
                    )}
                    {claimState == 'create' && (
                        <button className="btn btn-white" onClick={createPodcast}>Create</button>
                    )}
                    {claimState == 'email-view' && (
                        <>
                            <button className="btn btn-white" onClick={() => {
                                setClaimState('create');
                            }}>No</button>
                            <button className="btn btn-white" onClick={sendClaimEmail}>Yes</button>
                        </>
                    )}
                    {claimState == 'no-email' && (
                        <>
                            <button className="btn btn-white" onClick={verifyDescription}>Verify</button>
                        </>
                    )}
                    {claimState == 'email-sent' && (
                        <button className="btn btn-white" onClick={() => {
                            claimPodcastRef.current.hide();
                            closeDialog();
                        }}>Close</button>
                    )}
                </div>
            )}>
                <div style={{ flexGrow: 0, width: 400 }} className="w-100 p-rel">
                    {claimState == 'select' && (
                        <>
                            <label className="mb-25" style={{display: 'block', fontSize: '1.125em', fontWeight: 700}}>Select Your Podcast</label>
                            <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-col mb-10 flex f-start">
                                {podcastList.map(p => (
                                    <a role="button" key={p.id} className="podcast-select-button" onClick={() => claimPodcast(p.id)}>
                                        {p.name}
                                    </a>
                                ))}
                                {podcastList.length == 0 && (
                                    <div>There were no podcasts found.</div>
                                )}
                            </div>
                        </>
                    )}
                    {claimState == 'email-view' && (
                        <>
                            <label className="mb-25" style={{display: 'block', fontSize: '1.125em', fontWeight: 700}}>Is This Your Email?</label>
                            <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-col mb-10 flex f-wrap">
                                <b>{podcast.email}</b>
                            </div>
                        </>
                    )}
                    {claimState == 'no-email' && (
                        <>
                            <label className="mb-25" style={{display: 'block', fontSize: '1.125em', fontWeight: 700}}>Verification Required</label>
                            <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-col mb-10 flex f-wrap">
                                Copy and paste the code below into your latest episode's description: <code>{descriptionToken}</code> Once published, click the 'Verify' button. It may take a few minutes for your host to update the feed.
                            </div>
                        </>
                    )}
                    {claimState == 'email-sent' && (
                        <>
                            <label className="mb-25" style={{display: 'block', fontSize: '1.125em', fontWeight: 700}}>Verification Email Sent</label>
                            <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-col mb-10 flex f-wrap">
                                Please check your email to finish verification of the podcast.
                            </div>
                        </>
                    )}
                    {claimState == 'create' && (
                        <>
                            <label className="mb-25" style={{display: 'block', fontSize: '1.125em', fontWeight: 700}}>Create Your Podcast?</label>
                            <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-col mb-10 flex f-wrap">
                                Would you like to create and host your podcast on the Podcast Premium platform?
                            </div>
                        </>
                    )}
                </div>
            </Dialog>
            <div className="container-center">
                <div className="container mw-800 w-100 p-10">
                    <h1 className="mb-20"><b>Podcast</b></h1>
                    {lock && (
                        <div className="mb-10">
                            <Alert>
                                Check your email for the verification email.
                            </Alert>
                        </div>
                    )}
                    <div className="form">
                        <div className="w-100">
                        <div className="flex f-row w-100">
                            <label>Podcast Name</label>
                        
                            <div className="ml-auto f-row gap-10" style={{flexGrow: 0}}>
                                <label htmlFor="hosted-podcast">Hosted</label>
                                <label className="switch mb-0">
                                    <input type="checkbox" id="hosted-podcast" onChange={e => {
                                        dispatch({ key: 'hosted', value: e.target.checked});
                                    }} checked={podcast.hosted} />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                            <input type="text" disabled={lock} value={podcast.podcastName} onChange={(e) => { dispatch({ key: 'podcastName', value: e.target.value}) }} />
                        </div>
                        <div className="w-100 f-row f-end gap-10">
                            <button disabled={lock} className="btn" onClick={loadPodcasts}>
                                {loading ? (
                                    <div className="loading f-row">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                ) : <>Continue</>
                                }
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default JoinPodcast;